export const isMobile = (): boolean => {
    return window.innerWidth < 768
};

export const getDeviceOrientation = (): 'portrait' | 'landscape' => {
  return  window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
};

export const isMobileLandscapeOrientation = (): boolean => {
  const orientation = getDeviceOrientation();
  return orientation === 'landscape' && window.innerWidth < 900 && window.innerHeight < 500;
};

export const marketplaceScreenSettings: {[key: string]: number} = {
    width: 1440,
    height: 650,
    isFeatureAvailable: window.innerWidth >= 1440 && window.innerHeight >= 650 ? 1 : 0
};

export const delay = (time: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, time));
}

export const getAlphabet = () => {
  const alphabet = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
    'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
  ];

  return alphabet;
};

export const truncateText = (text: string, max_length: number): { text: string, origin_text: string, truncated: boolean} => {
    if (!text) { return { text: '', origin_text: '', truncated: false }; }
    if (text.length > max_length) {
      return { 
        origin_text: text,
        text: text.substring(0, max_length) + '...',
        truncated: true
      };
   }
   return { text: text, origin_text: text, truncated: false };
}

export const hideTooltipById = (tooltipId: string, additionalClasses?: string) => {
  const tooltip = document.getElementById(tooltipId) as HTMLElement;
  hideTooltip(tooltip, additionalClasses);
}

export const hideTooltip = (tooltip: HTMLElement, additionalClasses?: string) => {
  tooltip.style.visibility = 'hidden';
  tooltip.style.display = 'none';

  setTooltipClass(tooltip, `Tooltip-Tip ${additionalClasses || ''} right`);
}

export const showTooltipById = (tooltipId: string) => {
  const tooltip = getTooltipById(tooltipId);
  showTooltip(tooltip);
}

export const showTooltip = (tooltip: HTMLElement) => {
  tooltip.style.visibility = 'visible';
}

export const getTooltipById = (tooltipId: string) => {
  const tooltip = document.getElementById(tooltipId) as HTMLElement;
  return tooltip;
}

export const setTooltipClass = (tooltip: HTMLElement, className: string) => {
  tooltip.className = className;
}

export const setTooltipPosition = (tooltipId: string, defaultPosition: string, additionalClasses?: string): HTMLElement | null  => {
  let position = defaultPosition;
  let width = "";

  const tableContainer = document.getElementById('car-catalog-table-container');

  if (!tableContainer) {
    return null;
  }
  const tableContainerPosition = tableContainer.getBoundingClientRect();
  const tooltip = getTooltipById(tooltipId);

  if (!tooltip) {
    return null;
  }

  tooltip.style.display = 'block';
  setTooltipClass(tooltip, `Tooltip-Tip ${additionalClasses || ''} ${position}`);

  const startVisibleArea = tableContainerPosition.top + 50;
  const endVisibleArea = tableContainerPosition.bottom - 50;

  const tooltipPosition = tooltip.getBoundingClientRect();
  const isTooltipTopInvisible = tooltipPosition.top < startVisibleArea;
  const isTooltipBottomInvisible = tooltipPosition.bottom > endVisibleArea;
  const isTooltipFullyVisible = !isTooltipTopInvisible && !isTooltipBottomInvisible;

  if (isTooltipTopInvisible) {
    position = 'bottom';
  }

  if (isTooltipBottomInvisible) {
    position = 'top';

    if (tooltipId.includes("spec")) {
      if (tooltipPosition.top - startVisibleArea >= tooltipPosition.height) {
        // enough place to show tooltip on top
        position = "top";
      } else {
        // not enough place on both top and bottom,
        // so make width bigger and place it where more space exists
        width = 'Wide-Tooltip';
        const diffTop = tooltipPosition.top - startVisibleArea;
        const diffBottom = endVisibleArea - tooltipPosition.top;
        if (diffTop > diffBottom) {
          position = "top";
        } else {
          position = "bottom";
        }
      }
     
    }
  }

  if (isTooltipFullyVisible) {
    position = defaultPosition;
  }

  setTooltipClass(tooltip, `Tooltip-Tip ${additionalClasses || ''} ${position} ${width}`);

  return tooltip;
}

export const setCountClipsMenuPosition = (menuId: string, defaultHeight: number) => {
  const menu = document.getElementById(menuId) as HTMLElement;
  const bottomGap = 50;
  const topGap = 100;
  const minMenuHeight = 100;

  if (!menu) {
    return;
  }

  const tableContainer = document.getElementById('car-catalog-table-container');

  if (!tableContainer) {
    return;
  }

  // set initial style
  menu.style.top = '100%';
  menu.style.bottom = 'unset';
  menu.style.height = `${defaultHeight}px`;

  const tableContainerPosition = tableContainer.getBoundingClientRect();
  const startVisibleArea = tableContainerPosition.top;
  const endVisibleArea = tableContainerPosition.bottom - bottomGap;

  const menuPosition = menu.getBoundingClientRect();

  const isMenuTopInvisible = menuPosition.top < startVisibleArea;
  const isMenuBottomInvisible = menuPosition.bottom > endVisibleArea;
  const isTooltipFullyVisible = !isMenuTopInvisible && !isMenuBottomInvisible;
          
  if (isMenuBottomInvisible) {
      const heightToShow = menuPosition.height - (menuPosition.bottom - endVisibleArea);

      if (heightToShow > minMenuHeight) {
          menu.style.height = `${heightToShow}px`;
      } else {
          const height = menuPosition.top - startVisibleArea - topGap;
          
          menu.style.top = 'unset';
          menu.style.bottom = '100%';
          menu.style.height = height < defaultHeight ? `${height}px` : `${defaultHeight}px`;
      }
  }
}

export const formatDate = (date: Date | null, format: 'yyyy-mm-dd' | 'dd.mm.yyyy' | 'dd.mm.yy' | 'dd.mm.yyyy hh:mm'): string => {
  if (!date) {
    return '';
  }

  let day = String(date.getDate());
  let month = String(date.getMonth() + 1);
  let year = String(date.getFullYear());
  let hour = String(date.getHours());
  let minutes = String(date.getMinutes());

  if (day.length === 1) {
    day = `0${day}`;
  }

  if (month.length === 1) {
    month = `0${month}`;
  }

  if (hour.length === 1) {
    hour = `0${hour}`;
  }

  if (minutes.length === 1) {
    minutes = `0${minutes}`;
  }

  if (format === 'dd.mm.yyyy') {
    return `${day}.${month}.${year}`;
  }

  if (format === 'dd.mm.yy') {
    return `${day}.${month}.${year.slice(-2)}`;
  }

  if (format === 'yyyy-mm-dd') {
    return `${year}-${month}-${day}`;
  }

  if (format === 'dd.mm.yyyy hh:mm') {
    return `${day}.${month}.${year} ${hour}:${minutes}`;
  }

  return `${day}.${month}.${year}`;
}

export const getYearsAsDigits = (years: string): number[] => {
  if (!years) {
    return [];
  }
  let yearsWithoutSymbols = years.replace('(', '').replace(')', '').replace('-', '');
  let splittedYears = yearsWithoutSymbols.split(' ');
  let result = splittedYears.filter(x => x).map(x => +x);

  return result;
}

export const groupItemsBy = (list: any[], by: string, field: string) => {
  const result: any = {};
  list.forEach((item) => {
    const key = item[by];
    const value: any = item[field];

    if (result[key] && !result[key].includes(value)) {
      result[key] = result[key].concat(value);
    }

    if (!result[key]) {
      result[key] = [].concat(value);
    }
  });
  return result;
}

export const getSetMatsSubTitle = (setMats: string) => {
  const valuesMap: {[key: string]: string} = {
    'Два передніх': '1-й рядок',
    'Два передніх (суцільний або подвійний)': '1-й рядок',
    'Два передніх (суцільний або подвійний) + два задніх (суцільний або подвійний)': 'К-т до салону',
    'Два передніх (суцільний або подвійний) + задній (суцільний або подвійний)': 'К-т до салону',
    'Два передніх + два задніх': 'К-т до салону',
    'Два передніх + два задніх + дві перемички': 'К-т до салону',
    'Два передніх + два задніх + перемичка': 'К-т до салону',
    'Два передніх + дві перемички': '1-й рядок',
    'Два передніх + задній (суцільний або подвійний)': 'К-т до салону',
    'Два передніх + перемичка': '1-й рядок',
    'Два передніх + перемичка + два задніх + перемичка': 'К-т до салону',
    'Два передніх + перемичка + задній (суцільний або подвіний)': 'К-т до салону'
  }

  return valuesMap[setMats] || setMats;
};

export const copyToClipboard = (text: string) => {
  if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
  } else {
      const input = document.createElement('textarea');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
  }
}